import { render, staticRenderFns } from "./RehabCoursesHome.vue?vue&type=template&id=4bc78633&scoped=true"
import script from "./RehabCoursesHome.vue?vue&type=script&lang=js"
export * from "./RehabCoursesHome.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesHome.vue?vue&type=style&index=0&id=4bc78633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc78633",
  null
  
)

export default component.exports